export const OPEN_CP_NOTIFICATION_POPUP = 'OPEN_CP_NOTIFICATION_POPUP';

export const CLOSE_CP_NOTIFICATION_POPUP = 'CLOSE_CP_NOTIFICATION_POPUP';

export const SET_CP_NOTIFICATION_POPUP_SPACING = 'SET_CP_NOTIFICATION_POPUP_SPACING';
